import {
  Component,
  Input,
  EventEmitter,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CardListCell } from 'src/app/components/pages-partials/card-list/card-list-cell';
import { CardListCellTypes } from 'src/app/components/pages-partials/card-list/card-list-cell-types.enum';

@Component({
    selector: 'app-dynamic-data-list-table',
    templateUrl: './dynamic-data-list-table.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DynamicDataListTableComponent {
  @Input() items: string[];
  @Input() class: string;
  private _cellProps: CardListCell[] = [];
  get cellProps(): CardListCell[] {
    return this._cellProps;
  }
  @Input() set cellProps(cellProps: CardListCell[]) {
    this._cellProps = cellProps;
    this.titles = [];
    cellProps.map((column) =>
      this.titles.push(column.title ? column.title : '')
    );
  }

  public cellTypes = CardListCellTypes;
  public titles: string[];

  // todo *Resolver methods are called from template and slow down rendering quite a lot, think about optimizing it
  public typeResolver(cell: CardListCell, resolverArgs?: any): string {

    if (cell.type === null) return null;

    if (cell.type === CardListCellTypes.text) return 'text';
    if (cell.type === CardListCellTypes.link) return 'link';
    if (cell.type === CardListCellTypes.image) return 'image';
    if (cell.type === CardListCellTypes.icon) return 'icon';
    if (cell.type === CardListCellTypes.statusIcon) return 'statusIcon';
    try {
      var res = cell.type(resolverArgs);
      return res;
    } catch {}

    return null;
  }

  public resolveData(cell: CardListCell, resolverArgs?: any): string {
        if (!cell.textResolver) return '';
        return cell.textResolver(resolverArgs);
    }

    public footerResolver(cell: CardListCell, items: any[]): string {
        try {
            const sum = items.reduce((sum, current) => sum + current[cell.footer], 0);
            return cell.footerResolver ? cell.footerResolver(items, sum) : sum;
        }
        catch { }
    }
    
  public iconResolver(cell: CardListCell, resolverArgs?: any): string {
    return cell.icon
      ? cell.icon
      : cell.iconResolver
      ? cell.iconResolver(resolverArgs)
      : '';
  }

  public classResolver(cell: CardListCell, resolverArgs?: any): string {
    return cell.class
      ? cell.class
      : cell.classResolver
      ? cell.classResolver(resolverArgs)
      : '';
  }

  clickHandler(e, item, index) {
    e.preventDefault();

    this.cellProps[index].linkHandler
      ? this.cellProps[index].linkHandler(item, e)
      : this.linkClick.emit(item);
  }

  public hrefurl(e, item, index) {
    var res = this.cellProps[index].hrefResolver(item, e);    
    return res;
  }


  @Output() linkClick: EventEmitter<any> = new EventEmitter<any>();
}
